import React from 'react';
import { Text, Stack, Link } from 'basis';
import { LayoutPage, LayoutSection } from 'components';
import { Routes } from 'types';
import { useTheme } from 'theme';
import { useTrackingEvent } from 'hooks';

export const AssistedApplyClaimError: React.FC = () => {
  const theme = useTheme();
  const { trackEvent } = useTrackingEvent();

  const onTryAgainClick = () => {
    trackEvent({
      category: 'application',
      action: 'application-navigation',
      location: 'assisted-apply-claim-error',
      label: 'try again',
    });
  };

  return (
    <LayoutPage step="login">
      <LayoutSection>
        <Stack gap="8">
          <Text as="h1" textStyle="heading5" textStyle-md="heading4" color={theme.headingColor}>
            Unable to process your application
          </Text>
          <Text>
            We were unable to retrieve your application. Please make sure you have logged in with the
            email address and mobile number provided during your application.
          </Text>
          <Text>
            Please try again. If the issue persists, please contact us for assistance.
          </Text>
          <Link
            appearance="primary-button"
            variant="blue-button"
            href={Routes.init}
            newTab={false}
            onClick={onTryAgainClick}
          >
            Try again
          </Link>
        </Stack>
      </LayoutSection>
    </LayoutPage>
  );
};
